import FleerunStore from "../store";
import * as msal from "@azure/msal-browser";

const msalConfig = {
	auth: {
		clientId: null,
		authority: null
	},
	cache: {
		cacheLocation: "sessionStorage", // This configures where your cache will be stored
		storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
	}
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
const loginRequest = {
	scopes: [ "openid", "profile", "email" ]
};

const store = FleerunStore.store;

const aad = {
	authenticate: function(company, azureADApplicationId, azureADAuthority) {
		msalConfig.auth.authority = azureADAuthority;
		msalConfig.auth.clientId = azureADApplicationId;
		
		let myMSALObj = new msal.PublicClientApplication(msalConfig);
		return new Promise(function(resolve, reject) {
			myMSALObj
				.loginPopup(loginRequest)
				.then(loginResponse => {
					var data = {
					    company: company,
					    token: loginResponse.idToken
					};
					return store.dispatch("loginAAD", data)
						.then(() => {
							resolve();
						})
						.catch((err) => {
							reject(err);	
						});
				})
				.catch(err => {
					// TEST ONLY! Remove
					console.log("Errore provider auth: " + err);

					reject(err);
				});
		});
	},

	logout: function() {
		myMSALObj.logout().then(() => console.logout("AAD logged out"));
	}
};

export default aad;
